const PILL = {
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  passed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  complete: "bg-emerald-50 text-emerald-700 border-emerald-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
  overdue: "bg-rose-50 text-rose-700 border-rose-200",
  scheduled: "bg-sky-50 text-sky-700 border-sky-200",
  sent: "bg-sky-50 text-sky-700 border-sky-200",
  confirmed: "bg-sky-50 text-sky-700 border-sky-200",
  in_progress: "bg-blue-50 text-[#1286F2] border-blue-200",
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  requested: "bg-amber-50 text-amber-700 border-amber-200",
  open: "bg-amber-50 text-amber-700 border-amber-200",
};

export function Pill({ status, className = "" }) {
  const cls = PILL[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold capitalize ${cls} ${className}`} data-testid="status-pill">
      {String(status || "").replace(/_/g, " ")}
    </span>
  );
}

export function CCard({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white shadow-sm ${className}`}>{children}</div>;
}

export function CHead({ title, subtitle, action }) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="mt-1 text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
